import AnalyticCard from "../../analyticCard/analyticCard";

const LiveTrackCard = () => {
    return(
        <ul className="grid col-4">
            <AnalyticCard color={'#6995D0'}
                          backColor={'#EBFAFF'}
                          data={{number: 47, title: <span>Moving</span>}}/>
            <AnalyticCard color={'#DC903A'}
                          backColor={'#FFEBC8'}
                          data={{number: '04', title: <span>Idle<br/> Vehicles</span>}}/>
            <AnalyticCard color={'#36BA6E'}
                          backColor={'#E3F5EA'}
                          data={{number: 13, title: <span>Average<br/> Alerts</span>}}/>
            <AnalyticCard color={'#6088D0'}
                          backColor={'#F5F5F5'}
                          data={{number: '89', suf: '%', title: <span>Utiliza-<br/> tion</span>}}/>
        </ul>
    )
}

export default LiveTrackCard;
